import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import RegistrationSuccessPage from "@/pages/RegistrationSuccessPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import VehiclesPage from "@/pages/VehiclesPage";
import WorkOrdersPage from "@/pages/WorkOrdersPage";
import ArbeitskartePage from "@/pages/ArbeitskartePage";
import PdfExportPage from "@/pages/PdfExportPage";
import CompanySettingsPage from "@/pages/CompanySettingsPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import MitarbeiterPage from "@/pages/MitarbeiterPage";
import LagerPage from "@/pages/LagerPage";
import ProductionPage from "@/pages/ProductionPage";
import InventurPage from "@/pages/InventurPage";
import KabelbaumPage from "@/pages/KabelbaumPage";
import Layout from "@/components/Layout";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/registration-success" element={<RegistrationSuccessPage />} />
      
      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="kunden" element={<CustomersPage />} />
        <Route path="fahrzeuge" element={<VehiclesPage />} />
        <Route path="auftraege" element={<WorkOrdersPage />} />
        <Route path="mitarbeiter" element={<MitarbeiterPage />} />
        <Route path="lager" element={<LagerPage />} />
        <Route path="produktion" element={<ProductionPage />} />
        <Route path="kabelbaeume" element={<KabelbaumPage />} />
        <Route path="inventur" element={<InventurPage />} />
        <Route path="arbeitskarte" element={<ArbeitskartePage />} />
        <Route path="pdf-export" element={<PdfExportPage />} />
        <Route path="einstellungen" element={<CompanySettingsPage />} />
        <Route path="admin/users" element={<AdminUsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
